<template>
	<v-container>
		<v-card outlined>
			<v-card-title>
				Производители
				<create-machine-vendor-modal
					@created="handleVendorCreated"
				/>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col
						v-for="vendor in vendors"
						:key="vendor.id"
						lg="3"
						md="4"
					>
						<router-link
							:to="`/machines/vendors/${vendor.id}`"
							class="text-decoration-none body-1"
						>
							{{ vendor.name }}
						</router-link>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>

import CreateMachineVendorModal from '@/components/machines/create-vendor-modal.vue';

export default {
	name: 'MachineVendorsIndexView',
	components: {CreateMachineVendorModal},
	data: () => ({
		vendors: [],
	}),
	async created() {
		await this.fetchVendors();
	},
	methods: {
		async fetchVendors() {
			try {
				const response = await this.$http.get('/api/v2/schemes/machines/vendors', {
					params: {
						limit: 100,
					},
				});
				this.vendors = response.data.data;
			} catch (e) {
				console.error('Error fetching vendors');
			}
		},
		handleVendorCreated() {
			this.fetchVendors();
		},
	},
}
</script>

<style scoped>

</style>
